import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { IMAGES_PATH } from 'src/app/enums & constants/paths.constants';
import { Post } from 'src/app/models/post';
import { Viewer } from 'src/app/models/viewer';
import { MiradoresService } from 'src/app/services/miradores.service';
import { ModalViewerActivityComponent } from '../../modal-viewer-activity/modal-viewer-activity.component';

@Component({
  selector: 'app-new-mirador',
  templateUrl: './new-mirador.component.html',
  styleUrls: ['./new-mirador.component.scss'],
})
export class NewMiradorComponent implements OnInit {

  @Input() post: Post;
  @Output() onViewPhoto: EventEmitter<string> = new EventEmitter();
  
  loading: boolean = false;

  constructor(private router: Router, private MIService: MiradoresService, private modalController: ModalController) { }

  ngOnInit() {}

  seeDetail(mirador) {
    this.router.navigate([
      '/mirador',
      this.MIService.getNormalizedMiradorNameForURL(mirador.name),
    ]);
  }

  getUrlCover(cover) {
    return !cover.toLowerCase().startsWith("https://") ? `${IMAGES_PATH}miradores/${cover}` : cover;
  }

  async openCoverViewer(indexPhoto) {

    let data: Viewer = {
      title: this.post.mirador.name,
      photos: this.post.mirador.covers.map(item => {
        return { url: item, caption: '' }
      }),
      initialSlide: indexPhoto
    }
    const modal = await this.modalController.create({
      component: ModalViewerActivityComponent,  // Tu componente aquí
      componentProps: {  // Los datos que quieras pasar al componente
        data: data
      },
      cssClass: 'transparent-modal'
    });
    return await modal.present();
  }
}
